
    import { useContext, useEffect, useState } from 'react'
    import { Container, Draggable } from 'react-smooth-dnd';
    import GlobalContext from 'proj/contexts/global';
    import ClassNames from 'classnames';

    import * as Rank from './components';
    
    export default ( { ...props } ) =>
    {
        const { active, data, setActive, store, setStore, tracker } = useContext(GlobalContext);
        const { title, options, submit, module, topline, bottomline, ...select } = data?.sections[active] || {};
        
        const [init, setInit] = useState(false);
        const [items, setItems] = useState([]);

        // --------------------
        //  Events
        // --------------------

        const preventBehavior = (e) =>
        {
            e.preventDefault(); 
        };

        const onDrop = e =>
        {
            const transformedArray = [...items.slice(0, e.removedIndex), ...items.slice(e.removedIndex + 1, items.length)];
            transformedArray.splice(e.addedIndex, 0, items[e.removedIndex]);
            setItems(transformedArray);
        }

        const onDragStart = e =>
        {
            document.addEventListener("touchmove", preventBehavior, {passive: false});
        }

        const onDragEnd = e =>
        {
            document.removeEventListener("touchmove", preventBehavior, {passive: false});
        }

        const onSubmitClicked = e =>
        {
            if(module?.store)
            {
                setStore({ [module.store]: items });
            }

            if(module?.track)
            {
                const selection = items[0];
                const trackId = module.track.replace("{value}", selection?.value);
                tracker.trackMetric(trackId);
            }

            setActive(active + 1);
        }

        const onAnimationEnd = e =>
        {
            setInit(true);
        }

        // --------------------
        //  useEffect
        // --------------------

        useEffect(() =>
        {
            if(options?.input)
            {
                store[options.input].length == 1
                    ? setActive(active + 1)
                    : setItems(store[options.input]);   
            }
        }, []);

        // --------------------
        //  Build
        // --------------------

        const getItem = (val, id) => 
            <Draggable key={ `section-${active}-item-${id}` }>
                <Rank.Option 
                    className={ ClassNames(val?.class) }
                    onAnimationEnd={ id == (items.length - 1) ? onAnimationEnd : undefined }

                    data-id={ id }
                    idx={id}>
                        <Rank.OptionLabel text={ val?.label } />
                </Rank.Option>
            </Draggable>
            

        return items &&
            <Rank.Content className={ ClassNames(module?.class, {init}) }>
                { title && <Rank.Title text={ title } /> }
                { topline && <Rank.Instruction text={ topline } />}
                <Rank.OptionContainer>
                    <Container onDrop={ onDrop } onDragStart={ onDragStart } onDragEnd={ onDragEnd } dragBeginDelay={ 100 }>
                        { items && items.map(getItem) }
                    </Container>
                </Rank.OptionContainer>
                { bottomline && <Rank.Instruction text={ bottomline } />}
                { submit && <Rank.Submit className={ 'enabled' } text={ submit } onClick={ onSubmitClicked } /> }
            </Rank.Content>
    }